import { Helmet } from "react-helmet-async";

const BASE_URL = "https://drbenmagee.com";

// Person schema for Dr. Ben Magee
const personSchema = {
  "@context": "https://schema.org",
  "@type": "Person",
  "name": "Dr. Ben Magee",
  "url": BASE_URL,
  "image": "https://customer-assets.emergentagent.com/job_benmagee-preview/artifacts/ztxqh81h_PhotoRoom-20241206_145509-modified.png",
  "jobTitle": ["Author", "Serial Entrepreneur", "AI Governance Expert"],
  "description": "Dr. Ben Magee is an author, serial entrepreneur, U.S. Army veteran, AI governance expert, and nonprofit founder. PhD, CHS-III, CISSP, PMP | Member, MENSA International.",
  "alumniOf": {
    "@type": "Organization",
    "name": "U.S. Army"
  },
  "knowsAbout": ["AI Governance", "Financial Literacy", "Communication", "Entrepreneurship", "Veteran Affairs"],
  "sameAs": []
};

// WebSite schema
const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Dr. Ben Magee",
  "url": BASE_URL,
  "description": "Official website of Dr. Ben Magee — Author, Serial Entrepreneur, U.S. Army Veteran, AI Governance Expert, and Nonprofit Founder.",
  "publisher": {
    "@type": "Person",
    "name": "Dr. Ben Magee"
  }
};

// Organization schema for Reform Intelligence
const reformIntelligenceSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Reform Intelligence",
  "url": `${BASE_URL}/reform-intelligence`,
  "founder": {
    "@type": "Person",
    "name": "Dr. Ben Magee"
  },
  "description": "AI governance and responsible AI implementation consulting."
};

// Organization schema for VALOR
const valorSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "VALOR",
  "url": `${BASE_URL}/valor`,
  "founder": {
    "@type": "Person",
    "name": "Dr. Ben Magee"
  },
  "description": "Veterans serving veterans through advocacy, support, and community."
};

// Book schemas
const bookSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "Book",
    "name": "The Art of Small Talk",
    "author": { "@type": "Person", "name": "Dr. Ben Magee" },
    "bookFormat": "https://schema.org/Paperback",
    "url": "https://a.co/d/0c3WE4mk",
    "image": "https://customer-assets.emergentagent.com/job_benmagee-preview/artifacts/dwf08g25_artofsmalltalk-cover.PNG"
  },
  {
    "@context": "https://schema.org",
    "@type": "Book",
    "name": "The Art of Conversation",
    "author": { "@type": "Person", "name": "Dr. Ben Magee" },
    "bookFormat": "https://schema.org/Paperback",
    "url": "https://a.co/d/00pXXThp",
    "image": "https://customer-assets.emergentagent.com/job_benmagee-preview/artifacts/f1puz3kc_8532A7AA-E55D-456B-9172-440F3DB28520.PNG"
  },
  {
    "@context": "https://schema.org",
    "@type": "Book",
    "name": "The Art of Listening",
    "author": { "@type": "Person", "name": "Dr. Ben Magee" },
    "bookFormat": "https://schema.org/Paperback",
    "url": "https://a.co/d/06UV0H07",
    "image": "https://customer-assets.emergentagent.com/job_benmagee-preview/artifacts/8i61vzoy_kdp-book-cover.PNG"
  },
  {
    "@context": "https://schema.org",
    "@type": "Book",
    "name": "The Art of Asking Questions",
    "author": { "@type": "Person", "name": "Dr. Ben Magee" },
    "bookFormat": "https://schema.org/Paperback",
    "url": "https://a.co/d/0fwjo48A",
    "image": "https://customer-assets.emergentagent.com/job_benmagee-preview/artifacts/yf4v0vc9_book-cover.PNG"
  },
  {
    "@context": "https://schema.org",
    "@type": "Book",
    "name": "The Art of Persuasion",
    "author": { "@type": "Person", "name": "Dr. Ben Magee" },
    "bookFormat": "https://schema.org/Paperback",
    "url": "https://a.co/d/01EEgXiu",
    "image": "https://customer-assets.emergentagent.com/job_benmagee-preview/artifacts/ot23ed4a_95BD4385-8077-4EA0-9818-6F06077E626B.PNG"
  },
  {
    "@context": "https://schema.org",
    "@type": "Book",
    "name": "The Art of Negotiation",
    "author": { "@type": "Person", "name": "Dr. Ben Magee" },
    "bookFormat": "https://schema.org/Paperback",
    "url": "https://a.co/d/0fdCKp06",
    "image": "https://customer-assets.emergentagent.com/job_benmagee-preview/artifacts/aypixhgv_book-cover.PNG"
  },
  {
    "@context": "https://schema.org",
    "@type": "Book",
    "name": "The Art of Silence: How Strategic Silence Builds Authority and Influence",
    "author": { "@type": "Person", "name": "Dr. Ben Magee" },
    "bookFormat": "https://schema.org/Paperback",
    "url": "https://a.co/d/04959npG",
    "image": "https://customer-assets.emergentagent.com/job_benmagee-preview/artifacts/km6b9v0n_Canva.jpeg"
  },
  {
    "@context": "https://schema.org",
    "@type": "Book",
    "name": "The 12 Tenets of the Richest Man in Babylon",
    "author": { "@type": "Person", "name": "Dr. Ben Magee" },
    "bookFormat": "https://schema.org/Paperback",
    "url": "https://a.co/d/0a1Lsk7l",
    "image": "https://customer-assets.emergentagent.com/job_benmagee-preview/artifacts/pbhxubee_F759BD83-5A3B-4082-BC2A-C38791FE0000.PNG"
  },
  {
    "@context": "https://schema.org",
    "@type": "Book",
    "name": "In Wealth We Trust",
    "author": { "@type": "Person", "name": "Dr. Ben Magee" },
    "bookFormat": "https://schema.org/Paperback",
    "url": "https://a.co/d/0bSoo8n8",
    "image": "https://customer-assets.emergentagent.com/job_benmagee-preview/artifacts/x1zl8rf3_C3227A5B-F543-41E8-990C-6C15639A7E0A.PNG"
  },
  {
    "@context": "https://schema.org",
    "@type": "Book",
    "name": "Poverty Is A Mindset, Wealth Is A System",
    "author": { "@type": "Person", "name": "Dr. Ben Magee" },
    "bookFormat": "https://schema.org/Paperback",
    "url": "https://a.co/d/07s8QBGV",
    "image": "https://customer-assets.emergentagent.com/job_benmagee-preview/artifacts/z7vamvbz_Poverty_Is_A_Mindset_Wealth_Is_A_System_KDP_SAFE_6x9_300DPI.jpg"
  },
  {
    "@context": "https://schema.org",
    "@type": "Book",
    "name": "Understanding the Numbers (2nd Edition)",
    "author": { "@type": "Person", "name": "Dr. Ben Magee" },
    "bookFormat": "https://schema.org/Paperback",
    "url": "https://a.co/d/0fcgW9O6"
  }
];

export default function SEO({ 
  title, 
  description, 
  keywords, 
  canonical, 
  type = "website",
  jsonLd = null,
  page = "default"
}) {
  const siteTitle = "Dr. Ben Magee";
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} | Author, Entrepreneur, Veteran, AI Governance Expert`;
  const defaultDescription = "Dr. Ben Magee — Author, Serial Entrepreneur, U.S. Army Veteran, AI Governance Expert, and Nonprofit Founder. PhD, CHS-III, CISSP, PMP | Member, MENSA International.";

  // Determine which JSON-LD schemas to include based on page
  const getSchemas = () => {
    const schemas = [];
    
    // Always include person and website schema on home page
    if (page === "home" || page === "default") {
      schemas.push(personSchema, websiteSchema);
    }
    
    // Include all books schema on books page
    if (page === "books") {
      schemas.push(...bookSchemas);
    }
    
    // Include organization schemas on respective pages
    if (page === "reform-intelligence") {
      schemas.push(reformIntelligenceSchema);
    }
    
    if (page === "valor") {
      schemas.push(valorSchema);
    }
    
    // Include person schema on about page
    if (page === "about") {
      schemas.push(personSchema);
    }
    
    // Include custom JSON-LD if provided (for articles, events, etc.)
    if (jsonLd) {
      schemas.push(jsonLd);
    }
    
    return schemas;
  };

  const schemas = getSchemas();

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Dr. Ben Magee" />
      <meta property="og:url" content={canonical || BASE_URL} />
      {canonical && <link rel="canonical" href={canonical} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      
      {/* JSON-LD Structured Data */}
      {schemas.map((schema) => (
        <script 
          key={`schema-${schema["@type"]}-${schema.name || schema.url || ''}`} 
          type="application/ld+json"
        >
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
